const boxConfig = {
  clientID: process.env.REACT_APP_BOX_CLIENT_ID,
};

export default boxConfig;
